var _path, _circle, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyndicateCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6828 7.23555L18.4902 6.48377C18.2087 5.38512 17.6272 4.38905 16.8129 3.60829C15.9986 2.82761 14.9842 2.29345 13.8853 2.06552C12.7863 1.83759 11.646 1.92478 10.5934 2.3174C9.54086 2.71004 8.61761 3.3927 7.92925 4.28886C7.62161 4.68936 7.36642 5.1253 7.16809 5.58584L6.88642 6.23991L6.17619 6.18761C6.07907 6.18045 5.9808 6.1768 5.88151 6.1768C3.70484 6.1768 1.94031 7.94134 1.94031 10.118C1.94031 12.2947 3.70484 14.0592 5.88151 14.0592L5.90441 14.0591L5.91011 14.0591V14.0591H20.5622C21.4557 14.0591 22.3142 13.7015 22.9484 13.0625C23.5828 12.4233 23.9405 11.5546 23.9405 10.6473C23.9405 9.74003 23.5828 8.8714 22.9484 8.23214C22.3142 7.59314 21.4557 7.23555 20.5622 7.23555H19.4589H18.6828ZM6.24964 5.19031C6.1281 5.18136 6.00534 5.1768 5.88151 5.1768C3.15256 5.1768 0.940308 7.38905 0.940308 10.118C0.940308 12.847 3.15256 15.0592 5.88151 15.0592L5.91011 15.0591H20.5622C21.7234 15.0591 22.8371 14.5943 23.6582 13.7669C24.4793 12.9396 24.9405 11.8174 24.9405 10.6473C24.9405 9.47726 24.4793 8.3551 23.6582 7.52773C22.8371 6.70036 21.7234 6.23555 20.5622 6.23555H19.4589C19.1313 4.95701 18.4543 3.7967 17.505 2.88647C16.5556 1.97624 15.3719 1.35258 14.0883 1.08636C12.8048 0.820136 11.4729 0.92203 10.2439 1.38046C9.01499 1.83889 7.9383 2.63547 7.1362 3.6797C6.77774 4.14636 6.48055 4.65413 6.24964 5.19031Z",
    fill: "#13100D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9403,
    cy: 7.53125,
    r: 2,
    fill: "#13100D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9403,
    y: 8.53125,
    width: 2,
    height: 3,
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyndicateCloud);
export default __webpack_public_path__ + "static/media/syndicate-cloud.90fd6fe2020d1d190f9f4422676d3d3c.svg";
export { ForwardRef as ReactComponent };